import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FaPlusCircle, FaMinusCircle, FaCircle } from "react-icons/fa";

const ListaResumo = ({ item }) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <div className="folha-resumo-topo">
        <Button className="raiz-resumo-roteiro" onClick={() => item?.children && setIsOpened(!isOpened)}>
          {item?.children && item?.children.length === 0 ? (
            <FaCircle className="text-light" />
          ) : isOpened ? (
            <FaMinusCircle className="text-secondary" />
          ) : (
            <FaPlusCircle className="text-secondary" />
          )}
          {` ${item?.title}`}
        </Button>
      </div>
      {item?.children && (
        <div className={`folha-resumo-roteiro ${isOpened ? "" : "folha-vazia-resumo-roteiro"}`}>
          {item?.children?.length ? item.children.map((x) => <ListaResumo item={x} />) : ""}
        </div>
      )}
    </>
  );
};

export default ListaResumo;
